import { NgModule } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {KontoComponent} from "../kunde/konto.component";
import {BuchungEnabledGuard} from "./buchung-enabled.guard";
import {BuchungComponent} from "./buchung.component";
import {SigninEnabledGuard} from "./signin-enabled.guard";


const routes: Routes = [
  { path: 'buchung',  component: BuchungComponent, canActivate: [BuchungEnabledGuard]},
  { path: 'konto', component: KontoComponent, canActivate: [SigninEnabledGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes) ],
  exports: [RouterModule]
})
export class BuchungRoutingModule { }
